export const permissionsKeys = {
  all: () => ['permissions'] as const,
  wait: () => ['permissions', 'wait'] as const,
};
